import { Injectable } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';

@Injectable({
  providedIn: 'root'
})
export class StepperService {
  private stepper: MatStepper | undefined;
  
  constructor() { }

  setStepper(stepper: MatStepper) {
    this.stepper = stepper;
  }

  nextStep() {
    if (this.stepper) {
      this.stepper.next();
    }
  }

  prevStep() {
    if (this.stepper) {
      this.stepper.previous();
    }
  }

  setStepIndex(index: number) {
    if (this.stepper) {
      console.log(this.stepper);
      this.stepper.selectedIndex = index;
    }
  }

  getStepIndex() {
    if (this.stepper) {
      return this.stepper.selectedIndex;
    }
    return 0;
  }

}
